import { render, staticRenderFns } from "./CustomerFiles.vue?vue&type=template&id=44228b76"
import script from "./CustomerFiles.vue?vue&type=script&lang=js"
export * from "./CustomerFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports